module.exports = __webpack_public_path__ + "img/weibo.92ba3756.svg";